export default class NavBarPagesEnum {
    static adminPanel = "adminPanel";
    static history = "history";
    static profile = "profile";
    static home = "home";
    static contact = "contact";
}